import { loadStripe } from '@stripe/stripe-js';

let stripeInstance = null;

async function getStripe() {
  if (!stripeInstance) {
    const key = import.meta.env.VITE_STRIPE_PUBLIC_KEY || import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
    stripeInstance = await loadStripe(key);
  }
  return stripeInstance;
}

export const PLANS = {
  free: {
    name: 'Free',
    price: 0,
    features: ['50 exercises', '3 AI messages/day', '7-day progress history', 'Basic workout library'],
  },
  pro: {
    name: 'Pro',
    priceMonthly: 9.99,
    priceAnnual: 7.99,
    priceIdMonthly: 'price_pro_monthly',
    priceIdAnnual: 'price_pro_annual',
    features: ['Unlimited exercises', 'AI plan generator (3/mo)', 'Sport-specific plans', 'Full nutrition tracking', '90-day progress', '20 AI messages/day'],
    highlight: 'Most Popular',
  },
  elite: {
    name: 'Elite',
    priceMonthly: 19.99,
    priceAnnual: 15.99,
    priceIdMonthly: 'price_elite_monthly',
    priceIdAnnual: 'price_elite_annual',
    features: ['Everything in Pro', 'Unlimited AI plans', 'AI meal plans', 'AI progress analysis', 'Unlimited AI coach', 'Priority support', 'Competition prep mode'],
    highlight: 'Best for Athletes',
  },
};

export async function redirectToCheckout(priceId, userId) {
  const stripe = await getStripe();
  if (!stripe) {
    alert('Stripe is not configured. Add VITE_STRIPE_PUBLISHABLE_KEY to your environment.');
    return;
  }
  console.log('Checkout:', priceId, userId);
  alert('Stripe checkout would open here. Connect your backend endpoint /api/create-checkout-session that creates a Stripe Checkout Session and returns { sessionId }');
}
